import { licenseService, localStorageService } from '../../services/service-factory';
import { mapActions, mapState } from 'vuex';
import moment from 'moment';

import { LICENSE_MODULES, ACCESS_TO_REPORTS } from '../../../../../constants';

export default {
  data: function () {
    return {
      licenseService: undefined,
      localStorageService: undefined,
    };
  },
  computed: {
    ...mapState({
      license: (state) => state.license.license,
      isIIProject: (state) => state.license.isIIProject,
      isDIGITAL35Project: (state) => state.license.isDIGITAL35Project,
      isEKAVProject: (state) => state.license.isEKAVProject,
      isAVGProject: (state) => state.license.isAVGProject,
      isONEProject: (state) => state.license.isONEProject,
      isRPTradeModule: (state) => state.license.isRPTradeModule,
      isReportModule: (state) => state.license.isReportModule,
      isTicketProject: (state) => state.license.isTicketProject,
      isGMVAProject: (state) => state.license.isGMVAProject,
    }),
  },
  created: function () {
    this.licenseService = licenseService;
    this.localStorageService = localStorageService;
  },
  methods: {
    ...mapActions({
      setLicense: 'license/setLicense',
      setIIProject: 'license/isIIProject',
      setAVGProject: 'license/isAVGProject',
      setONEProject: 'license/isONEProject',
      setDIGITAL35Project: 'license/isDIGITAL35Project',
      setEKAVProject: 'license/isEKAVProject',
      setTicketProject: 'license/isTicketProject',
      setIsGMVAProject: 'license/isGMVAProject'
    }),
    async loadLicense(update = false) {
      const license = await this.licenseService.getLicense({ update });
      const leftDays = moment(license.validUntil).diff(moment(), 'd');
      this.setLicense({
        ...license,
        leftDays,
      });
      const { modules } = license;
      const II = [LICENSE_MODULES.SALES, LICENSE_MODULES.ONE, ...ACCESS_TO_REPORTS];
      let IIdetected = II.some((item) => modules.includes(item));

      this.setIIProject({
        isIIProject: IIdetected,
        isReportModule: ACCESS_TO_REPORTS.some((m) => modules.includes(m)),
        isRPTradeModule: modules.includes(LICENSE_MODULES.RPTRADE),
      });
      const isAVGProject = modules.includes(LICENSE_MODULES.AVG);
      const isONEProject = modules.includes(LICENSE_MODULES.ONE);
      console.log('modules.includes(LICENSE_MODULES.GMVA)', modules.includes(LICENSE_MODULES.GMVA));
      const isGMVAProject = modules.includes(LICENSE_MODULES.GMVA);

      if (isAVGProject) {
        const css = `
        *::-webkit-scrollbar {
          width: 10px !important;
        }
        `;
        const head = document.head || document.getElementsByTagName('head')[0];
        const style = document.createElement('style');
        head.appendChild(style);
        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
      }

      this.setAVGProject(isAVGProject);
      this.setONEProject(isONEProject);
      this.setIsGMVAProject(isGMVAProject);
      this.setDIGITAL35Project(modules.includes(LICENSE_MODULES.DIGITAL35));
      this.setEKAVProject(modules.includes(LICENSE_MODULES.EKAV));
      this.setTicketProject(modules.includes(LICENSE_MODULES.TICKETS));
      this.localStorageService.set('license', license);
    },
  },
};
